import { useComputed, useSignal } from "~/sdk/signal";
import Icon from "~/components/ui/Icon";
import Button from "~/components/ui/Button";
import { useWishlist } from "~/hooks/useWishlist";
import { useUser } from "~/hooks/useUser";

export interface Props {
  productID: string;
  productGroupID?: string;
  variant?: "icon" | "full";
}

function WishlistButton({
  variant = "icon",
  productGroupID,
  productID,
}: Props) {
  const { user } = useUser();
  const { loading, addItem, removeItem, getItem } = useWishlist();
  const listItem = useComputed(() => getItem(productID));
  const fetching = useSignal(false);

  const isUserLoggedIn = Boolean(user.value?.email);
  const inWishlist = Boolean(listItem.value);

  return (
    <Button
      className={variant === "icon"
        ? "hidden lg:block"
        : "btn-primary btn-outline gap-2"}
      loading={fetching.value}
      aria-label="Adicionar à lista"
      onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!isUserLoggedIn) {
          globalThis.alert("Please log in before adding to your wishlist");

          return;
        }

        if (loading.value) {
          return;
        }

        try {
          fetching.value = true;
          inWishlist
            ? await removeItem(productID)
            : await addItem(productID, productGroupID as string);
        } finally {
          fetching.value = false;
        }
      }}
    >
      <Icon
        id="Heart"
        className="text-[red]"
        size={19}
        strokeWidth={1}
        fill={inWishlist ? "red" : "none"}
      />
      {variant === "icon" ? null : inWishlist ? "Remover" : "Favoritar"}
    </Button>
  );
}

export default WishlistButton;
